/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BooksLibraryIcon16Light } from './BooksLibraryIcon16Light';
import { BooksLibraryIcon16Regular } from './BooksLibraryIcon16Regular';
import { BooksLibraryIcon16Solid } from './BooksLibraryIcon16Solid';
import { BooksLibraryIcon20Light } from './BooksLibraryIcon20Light';
import { BooksLibraryIcon20Regular } from './BooksLibraryIcon20Regular';
import { BooksLibraryIcon20Solid } from './BooksLibraryIcon20Solid';
import { BooksLibraryIcon24Regular } from './BooksLibraryIcon24Regular';
import { BooksLibraryIcon24Solid } from './BooksLibraryIcon24Solid';
import { BooksLibraryIcon32Regular } from './BooksLibraryIcon32Regular';
import { BooksLibraryIcon64Regular } from './BooksLibraryIcon64Regular';
var sizes = {
    16: {
        light: BooksLibraryIcon16Light,
        regular: BooksLibraryIcon16Regular,
        solid: BooksLibraryIcon16Solid,
    },
    20: {
        light: BooksLibraryIcon20Light,
        regular: BooksLibraryIcon20Regular,
        solid: BooksLibraryIcon20Solid,
    },
    24: {
        regular: BooksLibraryIcon24Regular,
        solid: BooksLibraryIcon24Solid,
    },
    32: {
        regular: BooksLibraryIcon32Regular,
    },
    64: {
        regular: BooksLibraryIcon64Regular,
    },
};
export var BooksLibraryIcon = forwardRef('BooksLibraryIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
